import { render } from "./TermsOfServiceView.vue?vue&type=template&id=1935372d&scoped=true"
import script from "./TermsOfServiceView.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceView.vue?vue&type=script&lang=js"

import "./TermsOfServiceView.vue?vue&type=style&index=0&id=1935372d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1935372d"]])

export default __exports__